import { useEffect, useState } from "react"
import { ArtBlocksTokenProvenanceMetadata, fetchArtBlocksTokenProvenance } from "utils/artBlocksMetadataApi"
import { isArtBlocksChainId } from "utils/artBlocksUrls"

const useTokenProvenance = (
  contractAddress?: string,
  tokenId?: string,
  chainId?: number | string | null,
  enabled = true
) => {
  const [data, setData] = useState<ArtBlocksTokenProvenanceMetadata | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!enabled || !contractAddress || !tokenId || !isArtBlocksChainId(chainId)) {
      setData(null)
      setLoading(false)
      setError(false)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(false)

    fetchArtBlocksTokenProvenance(contractAddress, tokenId, Number(chainId))
      .then((provenance) => {
        if (!cancelled) setData(provenance)
      })
      .catch(() => {
        if (!cancelled) {
          setData(null)
          setError(true)
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [chainId, contractAddress, enabled, tokenId])

  return { data, loading, error }
}

export default useTokenProvenance
